/** 스크린 가로 최대 사이즈 */
export const SCREEN_MAX_WIDTH = '1920px';

/** 스크린 가로 최소 사이즈 */
export const SCREEN_MIN_WIDTH = '1200px';

/** 메인화면 Global Padding */
export const SCREEEN_PADDING = 20;

/** 네이게이션 가로 사이즈 */
export const NAVIGATION_WIDTH = '250px';
